export default __webpack_public_path__ + "static/media/qode_blue.c722f1f8.svg";